import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProcedureDetailsViewTopBar } from "./TopBar"

export const procedureDetailsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProcedureDetailsViewTopBar,
}
